<div class="actionsheet-container">
  <button kendoButton (click)="clickHandler()">Open ActionSheet</button>

  <kendo-actionsheet title="ActionSheet" subtitle="Kendo UI for Angular" [items]="actionSheetItems"
    (overlayClick)="onOverlayClick()" (itemClick)="onItemClick()" [expanded]="opened">
  </kendo-actionsheet>
</div>
